import { Controller } from '@hotwired/stimulus'
import SweetScroll from 'sweet-scroll'

export default class NavigationController extends Controller {
  static targets = ['item', 'element', 'horizontal', 'vertical', 'lazyFrame']
  static values = { headerOffset: { type: Number, default: 0 } }

  connect () {
    this.scrollerHorizontal = new SweetScroll(this.optionsHorizontal, this.horizontalTarget)
    this.scrollerVertical = new SweetScroll(this.optionsVertical)
  }

  scrolled ({ params: { itemId, elementId } }) {
    if (this.isCurrent(elementId)) {
      this.itemTargets.forEach(item => (item.dataset.checked = 'false'))
      this.setCurrent(itemId)
      setTimeout(() => this.enableAllLazyFrames(), 1000)
    }
  }

  scrollToElement ({ params: { elementId } }) {
    const currentElement = this.elementTargets.find(el => el.id === elementId)

    if (currentElement != null) {
      this.disableLazyFramesAbove(currentElement)
      this.scrollerVertical.toElement(currentElement)
    } else {
      console.warn(`Element with ID ${String(elementId)} not found`)
    }
  }

  isCurrent (elementId) {
    const currentElement = this.elementTargets.find(el => el.id === elementId)

    if (currentElement == null) {
      return false
    }

    const rect = currentElement.getBoundingClientRect()
    const offset = this.headerOffsetValue
    return rect.top >= (this.negativeHeight - offset) && rect.top <= (this.maxHeight + offset)
  }

  setCurrent (id) {
    const currentItem = this.itemTargets.find(item => item.id.split('_').pop() === id)

    if (currentItem != null) {
      currentItem.dataset.checked = 'true'
      this.scrollerHorizontal.toElement(currentItem)
    } else {
      console.warn(`Item with id ${id} not found.`)
    }
  }

  disableLazyFramesAbove (targetElement) {
    const targetIndex = this.elementTargets.indexOf(targetElement)

    this.lazyFrameTargets.forEach(frame => {
      const parentElement = this.elementTargets.find(el => el.contains(frame))
      if (parentElement != null) {
        const parentIndex = this.elementTargets.indexOf(parentElement)
        if (parentIndex < targetIndex) {
          frame.disabled = true
        }
      }
    })
  }

  enableAllLazyFrames () {
    this.lazyFrameTargets.forEach(frame => {
      frame.disabled = false
    })
  }

  get optionsHorizontal () {
    return {
      easing: 'easeOutExpo',
      duration: 100,
      offset: -150,
      vertical: false,
      horizontal: true
    }
  }

  get optionsVertical () {
    return {
      header: this.verticalTarget,
      easing: 'easeOutExpo',
      duration: 100,
      offset: -this.headerOffsetValue
    }
  }

  get negativeHeight () {
    return this.maxHeight - this.element.offsetHeight
  }

  get maxHeight () {
    return 250
  }
}
